import { render } from "./App.vue?vue&type=template&id=3eb559d1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3eb559d1&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__